<template>
    <div class="header">
        <van-search placeholder="请输入搜索关键词" shape="round" :background="back_color" />
    </div>
</template>

<script>
    export default {
        name: "SearchHeader",
        props:{
            p_color:{
                type:String,
                default:'transparent', //#E34928
                required:false,
            },
        },
        data(){
            return {
                back_color:this.p_color,
            }
        }
    }
</script>

<style scoped lang="scss">
    .header {
        position: fixed;
        left: 0;
        top: 0;
        width: 100%;
        z-index: 10000;
    }
</style>